import React from 'react';
import PropTypes from 'prop-types';
import {Redirect, withRouter} from 'react-router-dom';
import {generateUrl, routes} from "helpers/routes";
import {connect} from 'react-redux';
import {setUser, logout} from "actions/user";
import {graphql, compose, withApollo} from "react-apollo";
import RefreshToken from 'gql/refresh.gql';
import moment from "moment";
import {errorCodes} from "./errors";

export const requireLoggedUser = (WrappedComponent) => {
    const component = withRouter(connect(
        state => ({user: state.user}),
        dispatch => ({onLogout: () => dispatch(logout())})
    )(
        class extends React.Component {
            static propTypes = {
                user: PropTypes.object,
                location: PropTypes.object.isRequired,
            };

            render() {
                const {user, location} = this.props;

                if (!user) {
                    return <Redirect to={generateUrl(routes.login, {}, {redirectUrl: location.pathname})}/>
                } else {
                    return (<WrappedComponent {...this.props} />);
                }
            }
        }
    ));
    component.displayName = `RequireLoggedUser(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return component;
};

export const withUser = (WrappedComponent) => {
    const component = connect(
        state => ({user: state.user}),
        dispatch => ({onLogout: () => dispatch(logout())})
    )(
        class extends React.Component {
            static propTypes = {
                user: PropTypes.object,
            };

            render() {
                return (<WrappedComponent {...this.props} />);
            }
        }
    );
    component.displayName = `RequireLoggedUser(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return component;
};

export const TokenRefresher = compose(
    connect(
    state => ({user: state.user}),
    dispatch => ({setUser: (user) => dispatch(setUser(user))}),
    ),
    graphql(RefreshToken, {name: 'refresh'}),
    withApollo
)(
    class extends React.Component {
        static propTypes = {
            user: PropTypes.object,
            setUser: PropTypes.func.isRequired,
            refresh: PropTypes.func.isRequired,
            client: PropTypes.object.isRequired,
        };

        constructor(props) {
            super(props);

            this.token = null;
            this.refreshTimer = null;
            this.logoutTimer = null;

            this.refreshToken = this.refreshToken.bind(this);
            this.setUser = this.setUser.bind(this);
            this.logout = this.logout.bind(this);
        }

        componentWillMount() {
            if (this.props.user) {
                this.setUser(this.props.user);
            }
        }

        componentWillReceiveProps(props) {
            if (this.props.user !== props.user) {
                this.setUser(props.user);

                if(props.user === null) {
                    window.location.reload(true);
                }
            }
        }

        logout() {
            this.token = null;
            this.props.setUser(null);
        }

        setUser (user) {
            if (!user) {
                this.token = null;
                if (this.refreshTimer) {
                    clearTimeout(this.refreshTimer);
                }

                if (this.logoutTimer) {
                    clearTimeout(this.logoutTimer);
                }

                return;
            }

            this.token = user.refreshToken;
            const now = moment();
            const expiration = moment.unix(user.expiresAt);
            const expiresIn = expiration.diff(now);
            if (expiresIn <= 0) {
                this.refreshToken();
            } else {
                this.refreshTimer = setTimeout(this.refreshToken, expiresIn / 2);
                if(this.logoutTimer) {
                    clearTimeout(this.logoutTimer);
                }
                this.logoutTimer = setTimeout(this.logout, expiresIn);
            }
        }

        refreshToken() {
            if(!this.token) {
                return;
            }
            this.props.refresh({
                variables: {
                    token: this.token,
                }
            }).then(({data}) => {
                const token = data.operatorLoginRefresh.token;
                let user = null;
                if (token) {
                    user = {
                        id: this.props.user.id,
                        accessToken: token.accessToken,
                        refreshToken: token.refreshToken,
                        expiresAt: moment().add(parseInt(token.expiresIn, 10), 'seconds').unix(),
                    };
                }
                this.props.setUser(user);
            }).catch(error => {
                console.log(Object.entries(error));
                if (error.graphQLErrors.length > 0 && error.graphQLErrors[0].code === errorCodes.refresh_token_not_found) {
                    this.logout();
                    return;
                }

                // Refresh in next half of time
                const now = moment();
                const expiration = moment.unix(this.props.user.expiresAt);
                const expiresIn = now.diff(expiration);
                if (expiresIn > 30000) {
                    this.refreshTimer = setTimeout(this.refreshToken, expiresIn / 2);
                }
            });
        }

        render() {
            return this.props.children;
        }
    }
);


// WEBPACK FOOTER //
// ./src/helpers/login.js